import { useCallback, useContext, useEffect } from "react";
import { ProfileContext } from "../../contexts/ProfileContext";
import { getAllCertificates } from "../../apis/impactCertificates/impactCertificates";
import AllMintedCards from "../gallery/minted/AllMintedCards";
import OverlayCardProject from "../../ui/OverlayCardProject";
import OverlayCard from "../../ui/OverlayCard";
import NoDataAvailable from "../../ui/NoDataAvailable";
import MintedProject from "../gallery/minted/MintedProject";
import MintedProjectBack from "../gallery/minted/MintedProjectBack";
import MintedCard from "../gallery/minted/MintedCard";
import MintedBack from "../gallery/minted/MintedBack";
import EmptyProjectIc from "../../ui/EmptyProjectIc";
import emptyProjectIc from "../../assets/emptyProcetIc.png";
import { useParams } from "react-router-dom";

function AllProjectCertificates() {
     const { state, dispatch } = useContext(ProfileContext);
     console.log(state,dispatch,"see this in all certs")
      const { projectId } = useParams();

       // fetch latest certificates
         const refreshCertificates = useCallback(async () => {
             try {
                 const fresh = await getAllCertificates();
                 console.log(fresh, 'fresh from gallery');
                 dispatch?.({ type: 'ic/setImpactcertificates', payload: fresh });
             } catch (err) {
                 console.error('Could not refresh impact certificates', err);
             }
         }, [dispatch]);
         // refresh certificates when gallery mounts
         useEffect(() => {
             refreshCertificates();
         }, [refreshCertificates]);
     const unclaimedIcs = state.filter((ic) => ic.status === 'UNCLAIMED');
     const claimedIcs = state.filter((ic) => ic.status === 'CLAIMED');
     const mintedIcs = state.filter((ic) => ic.status === 'MINTED' && ic?.projectId === projectId);
     const mintRequestedIcs = state.filter((ic) => (ic.status === 'MINT_REQUESTED' || ic.status === 'MINTING') && ic?.projectId === projectId);
    
    // Combine minted and non-minted project ICs
    const allProjectIcs = [...mintedIcs, ...mintRequestedIcs];
    return (
        <>
            <h1 className="text-lg mt-4 mb-[.375rem]  font-semibold text-textSecondary">All Certificates</h1>
            <div className="grid grid-cols-2 gap-[.875rem]">
            {allProjectIcs.length > 0 ? (
                        allProjectIcs.map((ic) => {
                            // For minted project ICs
                            if (ic.status === 'MINTED' && ic?.projectId) {
                                return (
                                    <OverlayCardProject
                                        width="w-full"
                                        height="h-[21.18rem]"
                                        fixW="w-full"
                                        key={ic.id + ic.status}
                                        image={ic.imageUri}
                                        ic={ic}
                                        FrontCard={MintedProject}
                                        BackCard={MintedProjectBack}
                                    />
                                );
                            }
                            // For non-minted project ICs (MINT_REQUESTED or MINTING)
                            else if ((ic.status === 'MINT_REQUESTED' || ic.status === 'MINTING') && ic?.projectId) {
                                return (
                                    <EmptyProjectIc
                                        width="w-full"
                                        height="h-[21.18rem]"
                                        fixW="w-full"
                                        key={ic.id + ic.status}
                                        image={emptyProjectIc}
                                        ic={ic}
                                        FrontCard={MintedProject}
                                        isFromAll={true}
                                    />
                                );
                            }
                            return null;
                        })
                    ) : (
                        <div className="flex w-full items-center col-span-2 justify-center">
                            <NoDataAvailable  marginTop="mt-3" />
                        </div>
                    )}
            </div>
        </>
    );
}

export default AllProjectCertificates